import EngineerInvoices from "../../views/Invoices/EngineerInvoices";

const EngineerInvoicesPage = () => {
  return <EngineerInvoices />;
};

export default EngineerInvoicesPage;
